import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ExecutionQTestDeviations } from "../model/execution";
import { HttpUtils } from "../utils/httpUtils";

@Injectable({
  providedIn: 'root'
})
export class ExecutionQDeviationService {

    readonly baseUrl = `${environment.qualificatesUrl}/deviation`
    constructor(private http: HttpClient) {
    }

    updateDeviation(idExecution: number, idExecutionTest: number, data: ExecutionQTestDeviations): Observable<any> {
        const url = `${this.baseUrl}/${idExecution}/${idExecutionTest}`;
        return this.http.put(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    getById(idDeviation: number): Observable<any> {
        const url = `${this.baseUrl}/${idDeviation}`;
        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    getDeviationByIdExecutionTest(idExecution: number, idExecutionTest: number): Observable<any> {
        const url = `${this.baseUrl}/execution/${idExecution}/${idExecutionTest}`;
        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    getDevCriticalByIdExecutionTest(idExecution: number, idTestType: number): Observable<any> {
        const url = `${this.baseUrl}/critical/${idExecution}/${idTestType}`;
        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    deleteDeviation(idExecution: number, idDeviation: number): Observable<any> {
        const url = `${this.baseUrl}/delete/${idExecution}/${idDeviation}`;
        return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
}
